import React from 'react';
import styles from './index.module.scss';
import localesReplacement from '../../utils/localesReplacement';
import {Replacement} from '../../interface';
import Marquee from 'react-fast-marquee';

import Warning from '../../images/warning.svg';

interface IProps {
  replacements: Replacement;
}

export const UnderMaintenance = (props: IProps) => {
  const {replacements} = props;
  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <img src={Warning} />
        <p>
          {localesReplacement(
            replacements,
            'This page is under maintenance. Please try again after some time.',
          )}
        </p>
      </div>
    </div>
  );
};

export default UnderMaintenance;
